import facebook from "../../../assets/icons/facebook-share.svg";
import twitter from "../../../assets/icons/twitter-share.svg";
import whatsApp from "../../../assets/icons/whatsApp-share.svg";
import illustration from "../../../assets/images/share-illustration.svg";
import Input from "../../../components/input";
import { showSuccessMessage } from "../../../hooks/constants";
import closeIcon from "../../../assets/icons/close.svg"



const ShareCampaign = ({onClose}) => {
    const campaignURL = window.location.href

    const shareOnFacebook = () => {
      const url = window.location.href;
      const message = `Hi, I'd really appreciate it if you could share or donate to this Mosquepay campaign.\n\n ${url}`;
      const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(message)}`;
      window.open(facebookURL, "_blank");
    };

    const shareOnWhatsApp = () => {
      const url = window.location.href;
      const message = `Hi, I'd really appreciate it if you could share or donate to this Mosquepay campaign.\n\n ${url}`
      const whatsappURL = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappURL, "_blank");
    };

    const shareOnTwitter = () => {
      const url = window.location.href;
      const message = `Hi, I'd really appreciate it if you could share or donate to this Mosquepay campaign. ${url}`;
      const twitterURL = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
      window.open(twitterURL, "_blank");
    };

    const handleCopy = () => {
      navigator.clipboard.writeText(campaignURL).then(() => {
        showSuccessMessage("Link copied!")
        // alert("Link copied to clipboard!");
      }).catch(err => {
        console.error("Failed to copy: ", err);
      });
    };

    return ( 
        <div className="fixed top-0 w-full h-screen bg-black/80 flex justify-center items-center px-4 z-50">
            <div className="bg-white max-h-[80%] md:max-h-[90%] overflow-y-auto w-full md:w-1/3 rounded">
                <div className="sticky top-0 bg-white flex justify-between items-center border-b px-6  py-5">
                  <p className="font-bold text-sm">Share campaign:</p>
                  <span className="cursor-pointer" onClick={onClose}> <img src={closeIcon} alt="" className="h-5 opacity-40 hover:opacity-100 transition-all"/> </span>
                </div>
                <div className="grid gap-2 px-6 py-5">
                  <p className="text-pretty text-secondary text-center text-sm">“Whoever guides someone to goodness will have a reward
                  like the one who did it.”</p>
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div onClick={shareOnWhatsApp} className="flex justify-center py-4 rounded border border-[#c4c4c416] hover:bg-brandGreen/5 transition-colors duration-500 cursor-pointer">
                        <div className="grid gap-2">
                          <div className="flex justify-center"><img src={whatsApp} alt="" className="h-8"/></div>
                          <span>WhatsApp</span>
                        </div>
                    </div>
                    <div onClick={shareOnFacebook} className="flex justify-center py-4 rounded border border-[#c4c4c416] hover:bg-brandGreen/5 transition-colors duration-500 cursor-pointer">
                        <div className="grid gap-2">
                          <div className="flex justify-center"><img src={facebook} alt=""  className="h-8"/></div>
                          <span>Facebook</span>
                        </div>
                    </div>
                    <div onClick={shareOnTwitter} className="flex justify-center py-4 rounded border border-[#c4c4c416] hover:bg-brandGreen/5 transition-colors duration-500 cursor-pointer">
                        <div className="grid gap-2">
                          <div className="flex justify-center"><img src={twitter} alt=""  className="h-8"/></div>
                          <span>Twitter - X</span>
                        </div>
                    </div>
                  </div>
                  <div className="relative">
                    <Input value={campaignURL} customStyles={"text-secondary"}/>
                    <div className="absolute top-0 right-0 h-full flex items-center me-2">
                      <span onClick={handleCopy} className="bg-white text-brandGreen text-sm p-2 border-s shadow-custom cursor-pointer">Copy</span>
                    </div>
                </div>
                </div>
                <div>
                  <img src={illustration} alt="" className="w-full"/>
                </div>
            </div>
        </div>
     );
}
 
export default ShareCampaign;